const guarantors = {
  bankGuarantee: 'Банковская гарантия',
  cadastralNumber: 'Кадастровый номер',
  rooms: 'Количество комнат',
  floor: 'Этаж',
  guarantor: 'Поручитель',
  guarantors: 'Поручители',
  property: 'Обеспечение',
  properties: 'Список обеспечений',
  realEstate: 'Недвижимость',
  apartment: 'Квартира',
  vin: 'vin номер',
  carNumber: 'Гос.номер',
  carYear: 'Год выпуска',
  mileage: 'Пробег',
  brand: 'Марка',
  guaranteeNumber: 'Номер',
  guaranteePeriod: 'Период',
  bank: 'Название банка',
  planAmount: 'Планируемая цена продажи',
  square: 'Площадь',
  depositCost: 'Залоговая стоимость',
  marketPrice: 'Рыночная стоимость',
  listOfGuarantors: 'Список поручителей',
  listOfProperties: 'Список обеспечений',
  documentIssuer: 'Выдал',
  documentNumber: 'Номер документа',
  issuerCode: 'Код подразделения',
  foundationDate: 'Дата основания',
  dateOfBirth: 'Дата рождения',
  placeOfBirth: 'Место рождения',
  legalCity: 'Город регистрации',
  legalAddress: 'Адрес регистрации',
  factCity: 'Фактический город проживания',
  factAddress: 'Фактический адрес',
  approvedBySb: 'Подтверждение СБ',
  sbComment: 'Комментарий СБ',
  phone1: 'Телефон 1',
  phone2: 'Телефон 2',
};

export default guarantors;
